// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__pRsCf","infoBtn":"quickbooks_infoBtn__1n3gi","formBox":"quickbooks_formBox__2Se6O","formFooter":"quickbooks_formFooter__2qeZT"};